import { BaseApi } from "./base";
import {GAME_APP, GAME_CONFIG} from "../enums/modules/game";

const apiUrlOtp = "/gameclient/common/";

export const AuthServiceAPI = {
  verifyToken(params) {
    return BaseApi.request(
      "post",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL +
        "/gameclient/" +
        "validate-game-token",
      params
    );
  },
  verifyPhone(params) {
    return BaseApi.request(
      "post",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL + apiUrlOtp + "send-otp",
      {
        ...params,
        app_id: GAME_APP.APP_ID
      }
    );
  },
  verifyOtp(params) {
    return BaseApi.request(
      "post",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL + apiUrlOtp + "validate-otp",
      params
    );
  },
};
